module.exports = __webpack_public_path__ + "static/media/img4.1ceb4970.jpg";